module.exports = __webpack_public_path__ + "static/media/fill.b35be2e5.svg";